/** Parse custom XML tags from AI assistant responses. */
export function parseCustomTags(customTag, content) {
    const customTagRegex = new RegExp(`<${customTag}>([\\s\\S]*?)<\\/${customTag}>`, 'gi');
    let customTagContent = null;
    const customTagMatches = content.match(customTagRegex);
    if (customTagMatches) {
        customTagContent = customTagMatches
            .map((m) => m.replace(`<${customTag}>`, '').replace(`</${customTag}>`, '').trim())
            .filter(Boolean)
            .join('\n\n');
    }
    const response = content.replace(customTagRegex, '').trim();
    return { customTagContent, response };
}
export function parseJsonArrayFromTagContent(customTagContent) {
    if (!customTagContent || customTagContent.trim().length === 0) {
        return [];
    }
    try {
        const parsed = JSON.parse(customTagContent);
        return Array.isArray(parsed) ? parsed : [parsed];
    }
    catch {
        return [customTagContent.trim()];
    }
}
/** Structured blocks embedded in assistant markdown (think, jobs, payloads, actions). */
export function parseAssistantResponse(content) {
    const thinkParsed = parseCustomTags('think', content);
    const thinkingParsed = parseCustomTags('thinking', thinkParsed.response);
    const jobParsed = parseCustomTags('job', thinkingParsed.response);
    const jobsParsed = parseCustomTags('jobs', jobParsed.response);
    const actionParsed = parseCustomTags('action', jobsParsed.response);
    const actionsParsed = parseCustomTags('actions', actionParsed.response);
    const payloadParsed = parseCustomTags('payload', actionsParsed.response);
    const payloadsParsed = parseCustomTags('payloads', payloadParsed.response);
    const thinking = [thinkParsed.customTagContent, thinkingParsed.customTagContent]
        .filter((part) => Boolean(part && part.trim().length > 0))
        .join('\n\n')
        .trim();
    const jobsRaw = [jobParsed.customTagContent, jobsParsed.customTagContent]
        .filter((part) => Boolean(part && part.trim().length > 0))
        .join('\n\n')
        .trim();
    const actionsRaw = [actionParsed.customTagContent, actionsParsed.customTagContent]
        .filter((part) => Boolean(part && part.trim().length > 0))
        .join('\n\n')
        .trim();
    const payloadsRaw = [payloadParsed.customTagContent, payloadsParsed.customTagContent]
        .filter((part) => Boolean(part && part.trim().length > 0))
        .join('\n\n')
        .trim();
    return {
        thinking: thinking.length > 0 ? thinking : null,
        jobs: parseJsonArrayFromTagContent(jobsRaw || null),
        actions: parseJsonArrayFromTagContent(actionsRaw || null),
        payloads: parseJsonArrayFromTagContent(payloadsRaw || null),
        response: payloadsParsed.response,
    };
}
